import { BLOGS } from "../types";

export const BlogsReducer = (state = [], action) => {
	const { type, payload } = action;

	switch (type) {
		case BLOGS: {
			const { data } = payload;
			state = [];
			return [...state, ...data];
		}

		default: {
			return state;
		}
	}
};
